import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Grid,
  Chip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

function AccountSelector({ accounts }) {
  const navigate = useNavigate();

  const handleSelectAccount = (accountId) => {
    navigate(`/accounts/${accountId}/dashboard`);
  };

  return (
    <Grid container spacing={3}>
      {accounts.map((account) => (
        <Grid item xs={12} md={6} lg={4} key={account.id}>
          <Card 
            sx={{ 
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              '&:hover': {
                boxShadow: 6,
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography variant="h6" gutterBottom>
                {account.name}
              </Typography>
              <Box sx={{ mb: 2 }}>
                <Chip 
                  label={account.type}
                  size="small"
                  sx={{ mr: 1 }}
                />
                <Chip 
                  label={account.role}
                  size="small"
                  color="primary"
                />
              </Box>
              <Typography color="text.secondary" variant="body2">
                Status: {account.status}
              </Typography>
              {account.nextDueDate && (
                <Typography color="text.secondary" variant="body2">
                  Next Payment: {new Date(account.nextDueDate).toLocaleDateString()}
                </Typography>
              )}
            </CardContent>
            <Box sx={{ p: 2, pt: 0 }}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => handleSelectAccount(account.id)}
              >
                Select Account
              </Button>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default AccountSelector; 